var _defs, _style, _use, _use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    width: 72,
    height: 72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 67,
    height: 67,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABDCAMAAADwFEhBAAAAAXNSR0IB2cksfwAAAH5QTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////snyM2gAAACp0Uk5TAAIIDxYdJCgqKy0JIiwhBRcmBhkUIB8BESkQGgMNEhgEJwsjFRwbDB4OCgocSAAAAZ1JREFUeJytmOuSgjAMhQNWgQgCorCKeHdd3/8Ft5V1FoEKbXJ+M9+kSUhzCqCR407EdOb5AQa+N5uKievoPtVoLsII3xUtxHw8IE5S7FeaxKMIyyzQEJSCbDlIcFbtM7QVrQYS466HEBKSux8IxddmkKC02Rbac5TDQfyFUu40ycxHEpTy3tRWuoL2K616ojBDSEgnkp3JQWrlrZwUpTECsXyvznZsRZqKtk2E61kgEL1GsxXmyaiV/59mb3MSpWj/QsS2CAl5zYKDNQLxUCOOPoHhH5+MhIBATJ5FOZEYJ1WaMwmBeJaMjMjIJONCZFzk8LJvjlqRAxURgVjBlcy4wo3M+IaQzAiB1mFKKdhNn6Y8+HRBj1MAZAQiSxwc+eCoC0d/cPQpx//C8d9yzA+OOcYyTznmOsf9AoLEEGz3Lce9D0uG/YNjD2LZxzj2Qpb91G5PzlouxmZf73gyBt8AcDf0L/cuwtBH/Wgs6s7Az2n9KYOvlHLzEf52/cnfAovPBg6/r0R/d3hqLhad94/Q5P2jlvN4e4d56LPwC0pwlp9twy0oAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 60,
    height: 57,
    id: "img2",
    href: "data:image/svg+xml;base64,PHN2ZyBpZD0ibGlua2VkaW4tbG9nbyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTkuNjM1IiBoZWlnaHQ9IjE4Ljc2MiIgdmlld0JveD0iMCAwIDE5LjYzNSAxOC43NjIiPgogIDxwYXRoIGlkPSJMaW5rZWRJbiIgZD0iTTE5LjYzNSwyMS4wNjFWMjguMzJIMTUuNDI2VjIxLjU0N2MwLTEuNy0uNjA5LTIuODYzLTIuMTMyLTIuODYzYTIuMywyLjMsMCwwLDAtMi4xNTksMS41MzlBMi44OCwyLjg4LDAsMCwwLDExLDIxLjI1djcuMDdINi43ODZzLjA1Ny0xMS40NzEsMC0xMi42NkgxMXYxLjc5NGMtLjAwOS4wMTMtLjAyLjAyOC0uMDI4LjA0MUgxMXYtLjA0MWE0LjE4LDQuMTgsMCwwLDEsMy43OTQtMi4wOTJDMTcuNTU5LDE1LjM2MywxOS42MzUsMTcuMTczLDE5LjYzNSwyMS4wNjFaTTIuMzgyLDkuNTU4YTIuMTk0LDIuMTk0LDAsMSwwLS4wNTYsNC4zNzVoLjAyOGEyLjE5NSwyLjE5NSwwLDEsMCwuMDI4LTQuMzc1Wk0uMjUsMjguMzJINC40NThWMTUuNjYxSC4yNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTkuNTU4KSIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4K"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "footer-linkdin",
    href: "#img1",
    x: 3,
    y: 3
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "linkedin-logo",
    href: "#img2",
    transform: "matrix(.414,0,0,.414,24,25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkdin);
export default __webpack_public_path__ + "static/media/footer-linkdin.2478a99a43e8252484cf48703be8c476.svg";
export { ForwardRef as ReactComponent };